export default "__VITE_ASSET__BfSpOPSI__"